const PAYER_LIST_ACTION_TYPES = {
  CHANGE_PAYER: 'CHANGE_PAYER',
  UPDATE_FORM_CONTROL_CONFIG: 'UPDATE_FORM_CONTROL_CONFIG',
  SET_ALL_PAYERS: 'SET_ALL_PAYERS',
  SET_REIMBURSEMENT_PAYERS: 'SET_REIMBURSEMENT_PAYERS',
  SET_GRIEVANCE_PAYERS: 'SET_GRIEVANCE_PAYERS',
  SET_EXACT_FILE_COUNT: 'SET_EXACT_FILE_COUNT',
};

export default PAYER_LIST_ACTION_TYPES;
